import classNames from 'classnames';
import Link from "next/link";
import React, { memo } from "react";

import { useSearchOverlayStore, useStickyHeaderStore, useStickyNewsletterStore, usePrimaryMenuStore } from "@/lib/stores/layout";
import Container from "@/components/Container/Container";
import Button from "@/components/Button/Button";
import IconSearch from '@/lib/assets/images/icon-search-w.svg';
// import IconClose from '@/lib/assets/images/cross-white.svg';
import IconLogo from '@/lib/assets/images/logo.svg';
import PostShare from "@/components/PostShare/PostShare";
import ThemeToggle from "@/components/ThemeToggle/ThemeToggle";
import HamburgerButton from '@/components/Button/HamburgerButton';
import UserNav from "@/components/Auth/UserNav";
import { useAuth } from '@/components/Auth/AuthProvider';

const HeaderTop = memo(function HeaderTop({ enableShare = false }) {
  const toggleNewsletter = useStickyNewsletterStore(state => state.toggle);
  const toggleSearch = useSearchOverlayStore(state => state.toggle);
  const isHeaderSticky = useStickyHeaderStore(state => state.sticky);
  const { user, loading, signOut } = useAuth() || {};

  const isUserLoggedIn = !!user;

  // const isSearchVisible = useSearchOverlayStore(state => state.visible);

  return (
    <div className={classNames(
      'py-2 transition-all bg-white dark:bg-black',
      { 'lg:py-4 xl:py-7': !isHeaderSticky },
      { 'lg:py-2': isHeaderSticky }
    )}>
      <Container className={classNames('grid grid-cols-2 lg:grid-cols-3')}>
        <div className={'flex items-center justify-start max-lg:hidden'}>
          <HamburgerButton className={'pl-0'} />
        </div>

        <Link
          href="/"
          className={classNames(
            'h-7 flex items-center',
            'lg:mx-auto transition-all md:transform-gpu',
            'lg:col-start-2 !text-black dark:!text-white',
            { 'lg:scale-[80%] xl:scale-[50%]': isHeaderSticky }
          )}
          aria-label={'Man of Many Homepage'}
          prefetch={false}
        >
          <IconLogo
            className="h-[28px] w-auto lg:h-[30px] xl:h-[40px]"
            viewBox="0 0 404 40"
            preserveAspectRatio="xMidYMid meet"
          />
        </Link>

        <div className={classNames(
          'lg:col-start-3',
          'flex items-center justify-end gap-x-2 lg:gap-x-3'
        )}>
          <Button
            variant={'icon'}
            onClick={toggleSearch}
            className={classNames(
              'text-black hover:text-navy',
              'dark:text-white hover:dark:text-silver',
              'hidden lg:block transition-none',
            )}
            aria-label="Toggle Search"
            title="Toggle Search"
          >
            {/* {isSearchVisible ? <IconClose/> : <IconSearch/>} */}
            <IconSearch />
          </Button>

          <ThemeToggle className={'hidden lg:block'} />

          <div className={classNames('relative')}>
            <Button
              variant={`fill`}
              size={isHeaderSticky ? 'small' : 'small'}
              onClick={toggleNewsletter}
              className={classNames([
                { 'opacity-0': (isHeaderSticky && enableShare) || isUserLoggedIn }
              ])}
            >Subscribe</Button>

            {(enableShare || isUserLoggedIn) && (
              <PostShare
                className={classNames(
                  'absolute left-0 top-0 opacity-0 z-[1] w-full transition',
                  { 'invisible': !isHeaderSticky && !isUserLoggedIn },
                  { 'opacity-100 visible': isHeaderSticky || isUserLoggedIn }
                )}
                variant={'fill'}
                size={`small`}
                shareDropdownArrowPosition={'end'}
              />
            )}
          </div>

          <UserNav className={'hidden lg:block'} />
        </div>
      </Container>
    </div>
  );
});

export default HeaderTop;
